import { Outlet, useLocation } from 'react-router-dom';

export const ScoutDashboardLayout = () => {
  const location = useLocation();

  const getActiveView = () => {
    if (location.pathname.includes('/edit-profile')) return 'editProfile';
    if (location.pathname.includes('/team-analysis')) return 'teamAnalysis';
    if (location.pathname.includes('/teams')) return 'teams';
    if (location.pathname.includes('/team/')) return 'teams';
    if (location.pathname.includes('/uncommitted-tracker')) return 'uncommittedTracker';
    if (location.pathname.includes('/statistics')) return 'statistics';
    if (location.pathname.includes('/player/')) return location.state?.from || 'uncommittedTracker';
    return 'dashboard';
  };

  const activeView = getActiveView();

  return (
    <Outlet context={{ activeView }} />
  );
};

export default ScoutDashboardLayout;
